import type { FieldSchema } from '@tsagko/label-contracts'
import type { EntityGroup } from './demo-schema'

const UNCATEGORIZED_KEY = 'fields'
const UNCATEGORIZED_ENTITY = 'Fields'

function titleCase(value: string): string {
  return value.length === 0 ? value : value.charAt(0).toUpperCase() + value.slice(1)
}

/**
 * Groups a flat `SessionContext.schemaMeta.fields` array into the same
 * `EntityGroup[]` shape the CmdK field picker renders for the hardcoded
 * demo schema (see `shell/demo-schema.ts`), bucketing by `FieldSchema.category`
 * and preserving first-seen category order and within-category field order.
 * Fields with no category (or an empty-string category) land in a trailing
 * "Fields" bucket.
 */
export function groupFieldsByCategory(fields: FieldSchema[]): EntityGroup[] {
  const order: string[] = []
  const byCategory = new Map<string, FieldSchema[]>()

  for (const field of fields) {
    const category = field.category && field.category.length > 0 ? field.category : UNCATEGORIZED_KEY
    if (!byCategory.has(category)) {
      order.push(category)
      byCategory.set(category, [])
    }
    byCategory.get(category)?.push(field)
  }

  return order.map(category => ({
    entity: category === UNCATEGORIZED_KEY ? UNCATEGORIZED_ENTITY : titleCase(category),
    fields: byCategory.get(category) ?? [],
  }))
}
